<template>
  <div>

    <div class="container">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-22">
                
              <div class="row">&nbsp;</div>

                <div class="product-btn" v-if="this.appoint.IsCanDelete">
                    <div class="row hidesmall">&nbsp;&nbsp;<strong>Beste {{this.appoint.CustomerName}}</strong></div>
                    <div class="row hidesmall titleMenuBasket">&nbsp;&nbsp;</div>
                    <div class="row">Wens je &nbsp;<strong>alle</strong>&nbsp; afspraken die doorgaan op <br> <strong>{{this.appoint.DateInfo}} </strong>&nbsp;&nbsp; afzeggen  ?</div>
                    <div class="row">&nbsp;</div>
                    <div class="row">
                     <div class="product-btn">
                      <a @click="cancelAppoint" v-bind:style="{ 'background-color': getColorApp}"  style="color:#fff;background-color:#ff0000"><i class="ion-bag" ></i>NEE</a>&nbsp;&nbsp;&nbsp;
                      <a @click="deleteAppoint" style="color:#fff;background-color:#ff0000"><i class="ion-bag" ></i>JA</a>
                    </div>
                    </div>
                </div>
                <div v-else>
                    {{this.appoint.Information}}
                </div>
                <div>{{this.deletemsg}}</div>

              <div class="row">&nbsp;</div>
              <div class="row">&nbsp;</div>
              <div v-if="this.isShowNewApp">
                  <router-link :to="'/'" class="product-link">
                     <div class="product-btn">
                      <a v-bind:style="{ 'background-color': getColorApp}"  style="color:#fff"><i class="ion-ios-plus-empty" ></i>Maak een nieuwe afspraak op</a>
                    </div>
                    </router-link>

              </div>
            </div>
            <div class="col-1"></div>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import myHttpApi from "../api/myhttpapi";
  import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from '../store/mutation-types'

  export default {
    components: {
    },
     data () {
      return {
        appoint : {},
        deletemsg : '',
        isDeleted : false,
        isShowNewApp : false,
        id : this.$route.params['id']
      }
    },
    mounted () {
      this.loadMyAppointments ();
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       }
    },
    methods: {
      cancelAppoint () {
          document.location = "/";
      },
      loadMyAppointments () {
          this.$store.commit(SPINNER_SHOW);
          const searchRec = {Token: this.id }
          myHttpApi.post( 'Account/GetAppointment', searchRec)
              .then(response => {
                 this.appoint = response.data;
                
                 this.$store.commit(SPINNER_HIDE);
              })
              .catch(error => {
                console.log(error);
                this.appoint = [];
                this.$store.commit(SPINNER_HIDE);
          });
      },
      deleteAppoint () {
        this.$store.commit(SPINNER_SHOW);
          const searchRec = {Token: this.appoint.Token }
          myHttpApi.post( 'Account/DelAppointment', searchRec)
              .then(response => {
                 this.$store.commit(SPINNER_HIDE);
                 this.appoint.IsCanDelete = false;
                 if (response.data.ResultCode == 0)
                 {
                    this.deletemsg = "Je afspraak is geannuleerd";
                 }
                 else
                 {
                    this.deletemsg = response.data.ErrorMsg;
                 }
                 this.isShowNewApp = true;
              })
              .catch(error => {
                console.log(error);
                this.appoint.IsCanDelete = false;
                deletemsg = "Fout bij verwerken";
                this.$store.commit(SPINNER_HIDE);
                this.isShowNewApp = true;
          });
      }
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/CustAppoint.vue